import script from "./BillConnectionIncome.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillConnectionIncome.vue?vue&type=script&setup=true&lang=ts"

import "./BillConnectionIncome.vue?vue&type=style&index=0&id=49403046&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49403046"]])

export default __exports__